import type { TFunction } from "i18next";
import { v4 as uuidv4 } from "uuid";

import type {
    AppConfigsFieldEntity,
    AppConfigsFormConfiguration,
    FormJson,
} from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import type { FormField, FormTab } from "../../../../components/Form/types/types";

export const mapFields = (data: readonly FormField[], t: TFunction) => {
    return data.map((item) => {
        const defaultValue = { componentType: item.component, value: item.attributes?.defaultValue };
        const displayName = t(item.translationKeys?.label) || item.name;
        const validations = { componentType: item.component, validations: item.attributes?.validationRules };
        // Note: visibility default is true unless stated otherwise
        const isIncluded = item.attributes?.visible !== false;
        const { name, component } = item;
        const watchedFields = item.attributes?.watchedFields;
        const condition = item.attributes?.condition;
        const readOnly = item.attributes?.readOnly;
        let urlToFetchOptions;
        if ("urlToFetchOptions" in item) {
            urlToFetchOptions = item.urlToFetchOptions;
        }
        return {
            name,
            component,
            displayName,
            isIncluded,
            validations,
            defaultValue,
            watchedFields,
            condition,
            urlToFetchOptions,
            readOnly,
            index: `${uuidv4()}`,
        } as AppConfigsFieldEntity;
    });
};

const mapTabs = (array: readonly FormTab[], t: TFunction) => {
    return array.map((childItem) => {
        const tabName = childItem.name;
        const configFields = childItem.fields ? childItem.fields : [];
        const fieldData = configFields && mapFields(configFields, t);
        return { header: tabName, key: `tab-${tabName}`, configFields: fieldData };
    });
};

// Convert Json Model to Collapse data structure
export const mapFormModelToCollapseModel = (json: FormJson, t: TFunction) => {
    if (!json) return [];
    return Object.entries(json).map((item) => {
        const formName = item[0];
        const formConfiguration = item[1];
        const tabChildren = formConfiguration.tabs || [];
        const tabData = tabChildren && mapTabs(tabChildren, t);
        return { header: formName, key: `form-${formName}`, configTabs: tabData } as AppConfigsFormConfiguration;
    });
};
